
import { verify_token } from "./auth";

export function authFecth(url, method, args={}, body={}) {
    return verify_token().then(verified => {
        if (!verified) {
            document.location.href = "/login"
        }
        else {
            const token = localStorage.getItem('access_token');
            var urlWithArgs = url;
            if (args) {
                const queryParams = new URLSearchParams(args).toString();
                urlWithArgs = `${url}?${queryParams}`
            }
            var fetchParams = {
                method: method,
                credentials: "include",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            if (method !== "GET" && body){
                fetchParams.body = JSON.stringify(body)
            }
            return fetch(urlWithArgs, fetchParams);
        }

    })
}